module.exports = __webpack_public_path__ + "static/media/home-block-1@2x.da31d57e.jpg";